// Constants for logo elements
export const DEFAULT_LOGO_IMAGE = 'https://d24wuq6o951i2g.cloudfront.net/img/site-assets/1dc.733.splash-black.png';
export const CONTENT_TYPE_CUSTOM_LOGO = 'custom';
export const CONTENT_TYPE_LIGHT_LOGO = 'light';
export const CONTENT_TYPE_DARK_LOGO = 'dark';
export const CUSTOM_LOGO_LABEL = 'Custom Logo';
export const LIGHT_LOGO_LABEL = 'Light Logo';
export const DARK_LOGO_LABEL = 'Dark Logo';

export const CONTENT_TYPE_LOGO_MAP = {
    [CONTENT_TYPE_CUSTOM_LOGO]: CUSTOM_LOGO_LABEL,
    [CONTENT_TYPE_LIGHT_LOGO]: LIGHT_LOGO_LABEL,
    [CONTENT_TYPE_DARK_LOGO]: DARK_LOGO_LABEL,
};
